var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.636 9.53479C19.7878 8.38301 19.7878 6.51561 18.636 5.36383C17.4843 4.21206 15.6169 4.21206 14.4651 5.36383L13.7998 6.02911C13.8089 6.05662 13.8184 6.08451 13.8282 6.11277C14.072 6.81562 14.5321 7.737 15.3976 8.60252C16.2631 9.46803 17.1845 9.92811 17.8874 10.172C17.9155 10.1817 17.9432 10.1911 17.9706 10.2002L18.636 9.53479Z",
    fill: "#081439"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.8289 6L13.8003 6.02864C13.8094 6.05615 13.8189 6.08405 13.8287 6.1123C14.0725 6.81515 14.5326 7.73654 15.3981 8.60205C16.2636 9.46756 17.185 9.92765 17.8879 10.1715C17.9157 10.1812 17.9433 10.1905 17.9704 10.1995L11.5501 16.6198C11.1172 17.0527 10.9008 17.2691 10.6621 17.4553C10.3806 17.6748 10.076 17.8631 9.75373 18.0167C9.48052 18.1469 9.19014 18.2437 8.60938 18.4373L5.54688 19.4581C5.26108 19.5534 4.94599 19.479 4.73297 19.266C4.51995 19.053 4.44557 18.7379 4.54084 18.4521L5.56167 15.3896C5.75526 14.8088 5.85205 14.5184 5.98226 14.2452C6.13585 13.9229 6.3241 13.6183 6.54367 13.3368C6.7298 13.0982 6.94623 12.8818 7.37906 12.4489L13.8289 6Z",
    fill: "#081439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlueIcon);
export default __webpack_public_path__ + "static/media/editBlueIcon.f127d828fb77f8b5b022ae1ed5148884.svg";
export { ForwardRef as ReactComponent };